import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {labels} from '../../../util/utils';

import {IconoirWarningTriangle} from '@ey-xd/motif-icon';

import StyledRelatedRiskIndicator, {StyledRelatedRiskIndicatorIcon} from './StyledRelatedRiskIndicator';

const RelatedRiskIndicator = ({
	assertion = null,
	relatedRisk = null,
	className = null,
	isRiskAssertion = false,
	...rest
}) => {
	const renderIcon = (props) => <StyledRelatedRiskIndicatorIcon src={IconoirWarningTriangle} {...props} />;

	const types = [
		{text: '-', className: 'not-relevant', condition: assertion === null},
		{
			text: 'H',
			title: labels.higherInheritRisk,
			className: 'higher',
			condition: !isRiskAssertion && assertion?.inherentRiskTypeId === 1
		},
		{
			text: 'L',
			title: labels.lowerInheritRisk,
			className: 'lower',
			condition: !isRiskAssertion && assertion?.inherentRiskTypeId === 2
		},
		{
			title: labels.incompleteInheritRisk,
			className: 'incomplete',
			condition: !isRiskAssertion && !(assertion?.assertionRisks?.length > 0),
			isIcon: true
		},
		{
			title: labels.riskAssociatedHigher,
			className: 'risk-higher',
			condition: isRiskAssertion && assertion?.inherentRiskTypeId === 1
		},
		{
			title: labels.riskAssociated,
			className: 'risk-lower',
			condition: isRiskAssertion && assertion?.inherentRiskTypeId === 2
		}
	];

	const type = types.find(({condition}) => condition === true);

	const props = {
		...rest,
		className: classNames({
			[`${type?.className}`]: type?.className ?? false,
			[`${className}`]: !!className
		})
	};

	if (!!type?.text) props.children = type.text;
	if (!!type?.title) props.title = type.title;

	if (type?.isIcon) return renderIcon(props);

	return <StyledRelatedRiskIndicator {...props} body2 />;
};

RelatedRiskIndicator.propTypes = {
	relatedRisk: PropTypes.oneOf(['H', 'L']),
	className: PropTypes.string,
	isRiskAssertion: PropTypes.bool
};

export default RelatedRiskIndicator;
